<template>
  <el-container class="js-container-p">
    <el-header>

      <el-menu mode="horizontal"  router :style="logUrl=='getAccountTest'?('background-color:#4A90E2'):('background-color:#3f4667')">
        <el-menu-item v-if="roleId==='777'" index="/welcome">
          <img  style="width: 60px;height: 60px" :src="imgUrl"/>
          <span style="color: white;font-size: 20px;margin-left: 5%;">{{title}}</span>
        </el-menu-item>
        <el-menu-item v-if="roleId==='619285375'" index="/welcome2">
          <img  style="width: 60px;height: 60px" :src="imgUrl"/>
          <span style="color: white;font-size: 20px;margin-left: 5%;">{{title}}</span>
        </el-menu-item>

<!--        <el-menu-item @click="allbox=true">-->
<!--          <span style="color: white;font-size: 17px;margin-left: 1%;">所有服务</span>-->
<!--          <i class="el-icon-right" style="font-size: 18px;color: white"></i>-->
<!--        </el-menu-item>-->

<!--        <el-menu-item index="/system/card">-->
<!--          <span style="color: white;font-size: 17px;margin-left: 1%;">SIM卡列表</span>-->
<!--        </el-menu-item>-->
<!--        <el-menu-item v-if="roleId==='777'" index="/system/equipment">-->
<!--          <span style="color: white;font-size: 17px;margin-left: 1%;">设备列表</span>-->
<!--        </el-menu-item>-->
<!--        <el-menu-item v-if="roleId==='777'" index="/system/resourcesList">-->
<!--          <span style="color: white;font-size: 17px;margin-left: 1%;">资源详情</span>-->
<!--        </el-menu-item>-->
        <!--<el-menu-item index="/system/disk_list">
          <span style="color: white;font-size: 17px;margin-left: 1%;">空间使用</span>
        </el-menu-item>-->

        <div style="display: inline-flex;float: right">
          <el-menu-item v-if="roleId==='5' &&username!=='南京杭兆坤'">
              <span style="margin-right: 5%;font-size: 15px;color: white">账户余额：{{agentCount}}</span>
              <span style="font-size: 15px;color: white">佣金金额：{{agentProfitCount}}</span>
          </el-menu-item>
          <el-menu-item index="/system/means" v-if="username!=='南京杭兆坤'">
              <i class="el-icon-s-finance" style="font-size: 18px;color: white"></i>
              <span  style="font-size: 15px;color: white;cursor:pointer">API文档</span>
          </el-menu-item>
          <el-menu-item index="/system/valueAdded" v-if="username!=='南京杭兆坤'">
              <i class="el-icon-camera" style="font-size: 18px;color: white"></i>
              <span  style="font-size: 15px;color: white;cursor:pointer">新版前端UI</span>
          </el-menu-item>
          <el-menu-item index="/system/task_list" v-if="username!=='南京杭兆坤'">
              <i class="el-icon-download" style="font-size: 18px;color: white"></i>
              <span  style="font-size: 15px;color: white;cursor: pointer">下载管理</span>
          </el-menu-item>
          <el-menu-item>
            <el-dropdown style="width: 100%;">
                        <span class="el-dropdown-link" style="">
                          <i class="el-icon-user-solid" style="font-size: 20px;color: white"></i>
                          <i style="" class="el-icon-caret-bottom"></i>
                        </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>{{username}}</el-dropdown-item>
                <el-dropdown-item @click.native="loginOut">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-menu-item>
        </div>
      </el-menu>
    </el-header>



    <el-container class="js-container">
      <el-aside style="margin-top: 60px" :width="isCollapse?'64px':'200px'">
        <el-menu  text-color="rgb(236 236 236)"  :default-active="defaultActive" router unique-opened :collapse="isCollapse">
          <el-submenu v-for="(item,index) in func" :key="index" :index="String(index)">
            <template slot="title">
              <i :class="item.icon" style="color: #3f4667"></i>
                  <span style="color: #3f4667">{{item.name}}
                   <!-- <span v-if="item.id===78 && isRead==='true'" class="dot">&nbsp;</span>-->
                  </span>
            </template>
            <el-menu-item v-for="(item1,dex) in item.childFunctionList" :key="dex" :index="item1.url">
              <span style="color: #3f4667">{{item1.name}}</span>
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </el-aside>
      <el-container>
        <el-main style="padding: 0 30px;margin-top: 50px;background: #F7F9FC;overflow-y: scroll;height: 100vh">
          <tabs @path="onTabs"></tabs>
          <!--  @before-remove="remove"  type="card"  @on-tab-remove="handleTabRemove" -->
          <router-view />
          <div style="height: 15vh"></div>
        </el-main>

      </el-container>
    </el-container>

<!--    <el-dialog-->
<!--               :visible.sync="allbox" width="100%"  top="6vh">-->
<!--      <div style="display: flex;flex-wrap: wrap">-->
<!--        <div v-for="(item,index) in func" :key="index" style="width: 20%;">-->
<!--        <div style="width:220px;height:180px;margin:0 auto;">-->
<!--          <div style="">-->
<!--            <span style="font-size: 15px;font-weight: 600;">{{item.name}}</span>-->
<!--          </div>-->
<!--          <div style="width: 100%;border: 0.3px solid rgb(51 51 51 / 43%)"></div>-->
<!--          <div style="height: 220px;display: inline-block">-->
<!--            <div  style="margin-top: 5%;" v-for="(item1,dex) in item.childFunctionList" :key="dex">-->
<!--              <div @click="goTo(item1)"  style="font-size: 13px;padding-right: 15px;cursor: pointer">{{item1.name}}</div>-->
<!--            </div>-->
<!--          </div>-->

<!--        </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </el-dialog>-->


  </el-container>
</template>
<script>
import tabs from './cp/Tags'
import calendarWrap from '../components/calendarWrap.vue'
export default {
  name: 'admin',
  components: {
    calendarWrap,
    tabs
  },
  data() {
    return {
      allbox:false,
      roleId:'',
      agentCount:0,
      agentProfitCount:0,
      deskinfo: '未获取到磁盘信息',
      rate: 0,
      isCollapse: false,
      noticeVisible: false,
      notice: {},
      routeName: '',
      deskInfo: '',
      defaultActive: '/welcome',
      mail: {
        createTime: '',
        title: '',
        desc: '',
        url: ''
      },
      infoDis: false,
      info: '暂无消息',
      cpu: 0,
      mem: 0,
      desk: 0,
      image: require('../static/img/avatar.png'),
      functions: [],
      func: {},
      childFunc: {},
      username: '',
      title: '',
      imgUrl: '',
      logUrl:'',
      isRead: localStorage.getItem('isRead')
    }
  },
  mounted: function () {
    let _this = this
    let user = JSON.parse(sessionStorage.getItem('loginUser'))
    _this.username = user.userName
    _this.roleId =user.roleId
    let sys_Menu = JSON.parse(sessionStorage.getItem('sys-Menu'))
    _this.logUrl = JSON.parse(sessionStorage.getItem('logUrl'))

    sys_Menu=null
    if (sys_Menu != undefined && sys_Menu != null) {
      _this.func = sys_Menu
      _this.loadMenuing()
    } else {
      _this.loadMenu()
    }
    //_this.loadFree()
    // 刷新时以当前路由做为tab加入tabs
    if (this.$route.path !== '/') {
      this.$store.commit('add_tabs', { route: this.$route.path, name: this.$route.name })
      this.$store.commit('set_active_index', this.$route.path)
    } else {
      this.$store.commit('add_tabs', { route: '/', name: '数据分析' })
      this.$store.commit('set_active_index', '/')
      this.$router.push('/')
    }
    //检测是否有新的投诉消息
    //this.pullViolationDesc()

  },

  methods: {
    pullViolationDesc(){
      let me = this
      setInterval(()=> {
        me.$ajax.get("/manager/violation/c-read").then(res => {
          if (res.data.code === "0") {
            let flag = res.data.data
            if (flag === 'true') {
              me.$message({
                message: '警告，有新的商户投诉通知',
                type: 'warning',
                showClose: true,
                duration: 5000
              })
            }
          }

        })
      },30000)
    },
    goTo(path){
      this.$router.push({path: path.url})
      this.allbox=false
    },
    godisklist(){
      this.$router.push({ path: "/system/disk_list" })
    },
    diskformat(percentage) {
      return percentage === 100 ? '满' : `${percentage}%`;
    },
    YO() {
      this.isCollapse = !this.isCollapse
    },
    loadFree() {
      let _this = this
      let disk = require("../api/disk")
      disk.getDisk().then(res => {
        if (res.data.code === '0') {
          let deskInfo = res.data.data.desk
          if (deskInfo == null) {
            return
          } else {
            _this.rate = deskInfo.rate
            _this.deskinfo = '磁盘总量：' + deskInfo.diskTotal + 'G' + '\r'
                    + '磁盘已用：' + deskInfo.diskUsed + 'G'
          }
        } else {
          _this.rate = 0
        }
      })
    },

    onTabs(on) {
      if (on == this.defaultActive) {
        return
      }
      this.defaultActive = on
    },
    // tab切换时，动态的切换路由
    tabClick(tab) {
      let path = this.activeIndex
      // 用户详情页的时候，对应了二级路由，需要拼接添加第二级路由
      if (this.activeIndex === '/welcome') {
        path = this.activeIndex
      }
      this.$router.push({ path: path })
    },
    tabRemove(targetName) {
      // 首页不可删除
      if (targetName === '/welcome') {
        return
      }
      this.$store.commit('delete_tabs', targetName)
      if (this.activeIndex === targetName) {
        // 设置当前激活的路由
        if (this.options && this.options.length >= 1) {
          this.$store.commit('set_active_index', this.options[this.options.length - 1].route)
          this.$router.push({ path: this.activeIndex })
        } else {
          this.$router.push({ path: '/welcome' })
        }
      }
    },



    loginOut() {
      let _this = this
      sessionStorage.clear()
      if(_this.logUrl=='getAccountTest'){
        _this.$router.push({
          name: 'loginTest'
        })
      }else if(_this.logUrl=='getAccountTestSystem'){
        _this.$router.push({
          name: 'loginTestSystem'
        })
      }else{
        _this.$router.push({
          name: 'login'
        })
      }
    },
    loadMenu() {
      let _this = this
      /**
       * 获取后台功能菜单数据
       */
      //console.log("进来了...")
      let account = JSON.parse(sessionStorage.getItem('loginUser'))
      if(!this.$check.checkIsNull(account)){
        _this.agentCount = account.agentCount.toFixed(2)
        _this.agentProfitCount=account.agentProfitCount.toFixed(2)
        _this.func = account.functionList.filter(x=>x.request==='0')
        _this.title=account.title
        _this.imgUrl='http://' + location.host+account.imgUrl
        sessionStorage.setItem('sys-Menu', JSON.stringify(_this.func))
        _this.loadMenuing()
      }
    },
    loadMenuing() {
      let _this = this
      //console.log("loadMenuing...");
      let sub = new Array()
      for (let i = 0; i < _this.func.length; i++) {
        let subFunc = _this.func[i].childFunctionList
        sub.push(subFunc)
        _this.childFunc = sub
      }
    }
  },

  computed: {
    options() {
      return this.$store.state.options
    },
    activeIndex: {
      get() {
        return this.$store.state.activeIndex
      },
      set(val) {
        this.$store.commit('set_active_index', val)
      }
    }
  },
  watch: {
    $route: {
      handler(to) {
        let flag = false
        this.routeName = to.name

        for (let option of this.options) {
          if (option.name === to.name) {
            flag = true
            this.$store.commit('set_active_index', to.path)
            break
          }
        }
        if (!flag) {
          this.$store.commit('add_tabs', { route: to.path, name: to.name })
          this.$store.commit('set_active_index', to.path)
        }
      },
      immediate: true
    }
  }
}
</script>

<style>
  /**
      * 当父级容器中有上下两个子类时，父级容器为百分百高度，子容器不能也为百分百
      */
  .js-container-p {
    height: 100%;
  }

  .js-container {
    /* 子容器的高度，需要通过相对高度，来把另一个子容器的高度进行排除
          */
    flex: 1 1 0%;
    box-sizing: border-box;
    overflow: hidden;
  }



  .js-scrollbar .el-scrollbar__wrap {
    overflow-x: hidden;
  }

</style>
<style scoped>

  .dot{
    vertical-align:text-top;display:inline-block;margin-left:4px;background-color:red;border-radius:50%;width:8px;height:8px;
  }

  /* 设置滚动条宽度和高度 */
  ::v-deep .el-aside::-webkit-scrollbar {
    width: 10px; /* 横向滚动条 */
    height: 10px; /* 纵向滚动条 必写 */
  }
  /* 设置滚动条样式 */
  ::v-deep .el-aside::-webkit-scrollbar-thumb {
    background-color: #dde;
    border-radius: 3px;
  }


  /*滚动条整体样式 此时为Y轴滚动，设置宽度，当为X轴滚动时，则设置高度*/
  .leftmenu::-webkit-scrollbar {
    width: 3px;
  }
  /*滚动条里面的滑块*/
  .leftmenu::-webkit-scrollbar-thumb {
    border-radius: 2px;
    background: #d5d5d5;
  }
  /*滚动条轨迹*/
  .leftmenu::-webkit-scrollbar-track {
    border-radius: 2px;
    background: #f1f1f1;
  }

  ::v-deep .el-submenu__title:hover{
    background-color: transparent!important;
  }

  ::v-deep .el-menu-item:hover{
    background-color: transparent!important;
  }

  ::v-deep .el-menu-item:not(:hover){
    background-color: transparent!important;
  }


  ::v-deep .el-menu{
    background-color:white;
  }

  ::v-deep .el-menu.el-menu--horizontal{
    border-bottom: none;
  }



  ::v-deep .el-header {
    padding: 0;
    position: absolute;
    width: 100%;
  }

  .dropdown-menu {
    min-width: 100% !important;
  }



  .js-container {
    /* 子容器的高度，需要通过相对高度，来把另一个子容器的高度进行排除
          */
    flex: 1 1 0%;
    box-sizing: border-box;
    overflow: hidden;
  }

  .js-aside {
    display: flex;
    flex-direction: column;
    overflow-x: hidden;
    height: 100vh;
  }

</style>
